import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Moment from 'moment'
import BillingCollapse from "../../../billings/BillingsPage/BillingCollapse";

class BillingHistoryRecord extends Component {

    state = {
        collapse: false
    }

    _toggleCollapse = () => {
        this.setState(prevState => ({
            collapse: !prevState.collapse
        }))
    }

    render() {
        const {bill, index} = this.props
        const {coupon, created, currency, price, method, title, updated, extend} = bill
        const {collapse} = this.state
        const timeHistory = updated || created
        const total = (price + 0).toFixed(2)
        const timeHistoryFormat = Moment(timeHistory).format('hh:mm:ss A, DD/MM/YYYY')
        const isCollapsable = !!extend

        return (
            <tr key={index}>
                <td><span>{timeHistoryFormat}</span></td>
                <td className="Name">
                    <span className="Text" onClick={this._toggleCollapse}>{title}
                        {
                            isCollapsable && <span className='extend-arrow'>&#x25BC;</span>
                        }
                    </span>
                    {
                        !!coupon && <span className="Coupon">{coupon}</span>
                    }
                    {
                        isCollapsable && <BillingCollapse collapse={collapse} extend={extend}/>
                    }
                </td>
                <td className="Method">{method}</td>
                {
                    !!price ? <td className="Price">{total} {currency}</td> : <td className="Price">Free</td>
                }
            </tr>
        )
    }
}

BillingHistoryRecord.propType = {
    bill: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
}

export default BillingHistoryRecord


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/user/UserPage/components/BillingHistoryRecord.js